// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export var InstrumentTypes;
(function (InstrumentTypes) {
    // внутренние типы
    InstrumentTypes[InstrumentTypes["ALL"] = -100] = "ALL";
    InstrumentTypes[InstrumentTypes["INS_HISTORY"] = -99] = "INS_HISTORY";
    InstrumentTypes[InstrumentTypes["NONE"] = -1] = "NONE";
    InstrumentTypes[InstrumentTypes["GENERAL"] = 0] = "GENERAL";
    // эти типы инструментов совпадают с серверными
    InstrumentTypes[InstrumentTypes["FOREX"] = 1] = "FOREX";
    InstrumentTypes[InstrumentTypes["EQUITIES"] = 2] = "EQUITIES";
    InstrumentTypes[InstrumentTypes["FUTURES"] = 3] = "FUTURES";
    InstrumentTypes[InstrumentTypes["OPTIONS"] = 4] = "OPTIONS";
    InstrumentTypes[InstrumentTypes["EQUITIES_CFD"] = 5] = "EQUITIES_CFD";
    InstrumentTypes[InstrumentTypes["FORWARD"] = 6] = "FORWARD";
    InstrumentTypes[InstrumentTypes["CFD_FUTURES"] = 7] = "CFD_FUTURES";
    InstrumentTypes[InstrumentTypes["INDICIES"] = 8] = "INDICIES";
    InstrumentTypes[InstrumentTypes["PORTFOLIO"] = 9] = "PORTFOLIO";
    InstrumentTypes[InstrumentTypes["CRYPTO"] = 10] = "CRYPTO";
    InstrumentTypes[InstrumentTypes["SPREADBET"] = 11] = "SPREADBET";
    InstrumentTypes[InstrumentTypes["FIXED_INCOME"] = 12] = "FIXED_INCOME";
    InstrumentTypes[InstrumentTypes["ETF"] = 13] = "ETF";
    InstrumentTypes[InstrumentTypes["TBILL"] = 14] = "TBILL";
    InstrumentTypes[InstrumentTypes["SPOT"] = 15] = "SPOT";
    InstrumentTypes[InstrumentTypes["CORPORATE"] = 16] = "CORPORATE";
    // CONTINIOUS_FUTURES = 17,
    InstrumentTypes[InstrumentTypes["FUND"] = 18] = "FUND";
})(InstrumentTypes || (InstrumentTypes = {}));
export const InstrumentTypesColor = {
    [InstrumentTypes.ALL]: '',
    [InstrumentTypes.INS_HISTORY]: '',
    [InstrumentTypes.GENERAL]: '',
    [InstrumentTypes.NONE]: '',
    [InstrumentTypes.FOREX]: '#298ACC',
    [InstrumentTypes.EQUITIES]: '#FF6767',
    [InstrumentTypes.FUTURES]: '#CC7300',
    [InstrumentTypes.OPTIONS]: '#811ACC',
    [InstrumentTypes.CFD_FUTURES]: '#AF69CC',
    [InstrumentTypes.EQUITIES_CFD]: '#AF69CC',
    [InstrumentTypes.INDICIES]: '#CCA832',
    [InstrumentTypes.PORTFOLIO]: '#808080',
    [InstrumentTypes.CRYPTO]: '#2ECCB8',
    [InstrumentTypes.SPREADBET]: '#9BCC07',
    [InstrumentTypes.FIXED_INCOME]: '#3FCC58',
    [InstrumentTypes.ETF]: '#78A9CC',
    [InstrumentTypes.TBILL]: '#CC4F6E',
    [InstrumentTypes.SPOT]: '#21998E',
    [InstrumentTypes.FORWARD]: '#09991E',
    [InstrumentTypes.CORPORATE]: '#5E46CC',
    // [InstrumentTypes.CONTINIOUS_FUTURES]: '#FFA42F',
    [InstrumentTypes.FUND]: '#005DCC'
};
const InstrumentTypesShortName = {
    [InstrumentTypes.ALL]: 'ALL',
    [InstrumentTypes.INS_HISTORY]: 'CUS',
    [InstrumentTypes.GENERAL]: 'GEN',
    [InstrumentTypes.NONE]: '',
    [InstrumentTypes.FOREX]: 'FX',
    [InstrumentTypes.EQUITIES]: 'EQ',
    [InstrumentTypes.FUTURES]: 'FUT',
    [InstrumentTypes.OPTIONS]: 'OPT',
    [InstrumentTypes.CFD_FUTURES]: 'CFD',
    [InstrumentTypes.EQUITIES_CFD]: 'CFD',
    [InstrumentTypes.INDICIES]: 'IND',
    [InstrumentTypes.PORTFOLIO]: 'SI',
    [InstrumentTypes.CRYPTO]: 'CRY',
    [InstrumentTypes.SPREADBET]: 'SB',
    [InstrumentTypes.FIXED_INCOME]: 'FI',
    [InstrumentTypes.ETF]: 'ETF',
    [InstrumentTypes.TBILL]: 'T-B',
    [InstrumentTypes.SPOT]: 'SPT',
    [InstrumentTypes.FORWARD]: 'FW',
    [InstrumentTypes.CORPORATE]: 'COR',
    // [InstrumentTypes.CONTINIOUS_FUTURES]: 'FUT',
    [InstrumentTypes.FUND]: 'FND'
};
export function getInstrumentTypeShortName(instrumentType) {
    return InstrumentTypesShortName[instrumentType];
}
